import { render, staticRenderFns } from "./eight.vue?vue&type=template&id=4a85e9b8&scoped=true&"
import script from "./eight.vue?vue&type=script&lang=js&"
export * from "./eight.vue?vue&type=script&lang=js&"
import style0 from "./eight.vue?vue&type=style&index=0&id=4a85e9b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85e9b8",
  null
  
)

export default component.exports